// extracted by mini-css-extract-plugin
export default {"container":"audio_container__39KQR","inner":"audio_inner__1D9Tg","controls":"audio_controls__3jw7R","button":"audio_button__2DtyQ"};